import { Checkbox, Flex, Typography } from '@banhala/ui-kit';
import { useAtomValue, useSetAtom } from 'jotai';
import { useMyPersonalizationForm } from '../state';

type PrivacyAgreementProps = {
  onViewAll: () => void;
};

const PrivacyAgreement = ({ onViewAll }: PrivacyAgreementProps) => {
  const { formAtom, togglePrivacyAgreementAtom } = useMyPersonalizationForm();
  const checked = useAtomValue(formAtom).checksPrivacyAgreement;
  const onToggle = useSetAtom(togglePrivacyAgreementAtom);

  return (
    <Flex.Row
      alignItems="center"
      padding={{ vertical: 8 }}
    >
      <Flex.Row
        flex={1}
        alignItems="center"
        padding={{ left: 16, top: 4, bottom: 4 }}
        onPress={onToggle}
      >
        <Checkbox value={checked} onPress={onToggle} />
        <Flex flex={1} padding={{ left: 8 }}>
          <Typography type="body2" color="content_secondary">
            (필수) 개인정보 수집 및 이용에 동의합니다.
          </Typography>
        </Flex>
      </Flex.Row>
      <Flex padding={{ horizontal: 16, vertical: 8 }} onPress={onViewAll}>
        <Typography
          type="body2"
          color="content_secondary"
          textDecorationLine="underline"
        >
          전체보기
        </Typography>
      </Flex>
    </Flex.Row>
  );
};

export default PrivacyAgreement;
